const {REACT_APP_API_DOMAIN, REACT_APP_API_VERSION} =	process.env
// const API_VERSION =	process.env?.REACT_APP_API_VERSION
// console.log({REACT_APP_API_DOMAIN, REACT_APP_API_VERSION})
export const API_URL = `${REACT_APP_API_DOMAIN}/api/`
export const API_VERSION = REACT_APP_API_VERSION
